import {Component, ElementRef, Input, OnInit} from '@angular/core';
import {Loader, LoaderService} from './loader.service';

@Component({
    selector: 'loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit{
    public loaders: Loader[] = [];

    @Input('loaderName')
    public loaderName: string;

    constructor(
        private loaderService: LoaderService,
    ) {
        this.loaderService.loaderStatus$.subscribe(
            loader => {
                console.log(loader, this.loaderName);
                if (!loader.status) {
                    setTimeout(() => {
                        this.loaders[loader.loaderName] = loader;
                    }, 1000)
                } else {
                    this.loaders[loader.loaderName] = loader;
                }

                console.log(this.loaders );

            }
        );
    }

    ngOnInit(): void {
        console.log('loader com', this.loaderName);


    }
}


// WEBPACK FOOTER //
// /code/frontend/src/app/core/loader/loader.component.ts